'use strict';

import './modules/polyfill-foreach.js';
import './modules/keyboard-mouse.js';
import './modules/search-toggle.js';
import './modules/timeline.js';
import initHamburgerMenu from './modules/hamburger-menu.js';
import scrollToTop from './modules/scroll-to-top.js';
import initWikiAccordion from './modules/wiki-accordion.js';
import initStudentStoriesCarousel from './modules/student-stories-carousel.js';

// Initialize hamburger menu
initHamburgerMenu();
// Initialize scroll to top
scrollToTop();
// Initialize wiki accordion
initWikiAccordion();
// Initialize student stories carousel when layout is ready (images/iframes loaded) so dimensions are stable in prod
if (document.readyState === 'complete') {
	initStudentStoriesCarousel();
} else {
	window.addEventListener('load', initStudentStoriesCarousel);
}
